<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="400px"
    :close-on-click-modal="false"
    class="app-main-inner settlement-select-dialog"
    :append-to-body="appendToBody"
  >
    <div class="app-main-inner-row" style="padding: 8px 16px 0 16px;">
      <el-input v-model="keyword" no="keyword" :placeholder="$t('Message.EnterKeyword')" style="padding-left: 2px;" @input="onKeywordInput" />
    </div>
    <div class="app-main-inner-row" style="padding: 8px 16px 0 16px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="tree.gridOptions"
        :row-data="filterRowData"
        style="width:350px;height:300px;padding-left:2px"
        @gridReady="params=>tree.gridApi=params.api"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-button no="clear" type="primary" style="float: left;margin-left: 46px;" @click="clearAll">{{ $t('Message.ClearSelectedItems') }}</el-button>
      <el-button no="ok" type="primary" @click="save()">{{ $t('common.btn.ok') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { ROW_SELECTION_MULTIPLE, ROW_SELECTION_SINGLE } from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'TreeEditor',
  props: {
    visible: { type: Boolean, required: true },
    path: { type: String, required: true },
    appendToBody: { type: Boolean, default: false },
    rowSelection: { type: String, default: ROW_SELECTION_MULTIPLE.code }, // 是否校验类型权限
    title: { type: String, required: true }, // 弹窗标题
    rowData: { type: Array, default: () => [] }
    // selectErrorTip: { type: String, default: '' } // 选择一级数据提示
  },
  data() {
    return {
      innerVisible: false,
      keyword: '',
      tree: {
        gridOptions: {
          // 自行实现多选
          // rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: '',
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.name}`
                }
                return params.data.name
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                if (this.rowSelection === ROW_SELECTION_SINGLE.code) {
                  // 重置所有选中
                  if (checked) {
                    this.rowData.forEach(item => {
                      item.checked = false
                    })
                  }
                }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      filterRowData: []
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true

      this.showtree()
      this.onKeywordInput()
    }
  },
  methods: {
    showtree() {
      this.rowData.forEach(item => {
        if (item.path === this.path) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    },

    save() {
      const row = this.rowData.find(p => p.checked)
      // 找产品确认下，这里参考文件类型
      // if (row.type === 1) {
      //   if (this.selectErrorTip) {
      //     this.$message.error(this.selectErrorTip, [row.name])
      //   }
      //   return
      // }
      let data = {}
      if (row) {
        data = { path: row.path, name: row.name }
      }
      this.$emit('callback', data)
      this.innerVisible = false
    },
    onKeywordInput() {
      if (this.keyword) {
        const matchPathes = []
        for (const row of this.rowData) {
          if (row.name.indexOf(this.keyword) > -1) {
            matchPathes.push(row.path)
          }
        }
        this.filterRowData = []
        for (const row of this.rowData) {
          for (const matchPath of matchPathes) {
            if (matchPath.startsWith(row.path) || row.path.startsWith(matchPath)) {
              this.filterRowData.push(row)
              break
            }
          }
        }
        this.$nextTick(() => {
          this.tree.gridApi.expandAll()
        })
      } else {
        this.filterRowData = this.rowData
      }
    },
    clearAll() {
      for (const row of this.rowData) {
        row.checked = false
      }
      this.tree.gridApi.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">
  .settlement-select-dialog {
    .ag-header {
      display: none;
    }
  }
</style>
